<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BuildingInfoPanel from '../../../../../../buildings/components/panels/BuildingInfoPanel.vue'

import { Building } from '../../../../../../buildings/models/building'
import { Site } from '../../../../../../sites/models/site'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { site, building } = defineProps<{
  site: Site
  building: Building
}>()
</script>

<template>
  <BuildingInfoPanel :site="site" :building="building" />
</template>
